export const BlockBookingText = {
  OTHER_BOOKED: 'Other desk booked',
  ALREADY_BOOKED: 'Already Booked',
  NOT_AVAILABLE: 'Not Available',
  RESOLVE_CONFLICTS_ON_NEXT_STEP: 'Resolve conflicts on next step',
  NOT_APPLICABLE: 'Not Applicable',
  AVAILABLE: 'Available',
  AVAILABLE_HALF: 'Available (Half Day)',
}
